module.exports = __webpack_public_path__ + "fonts/PlusJakartaSans-ExtraLight.ab2b6322.ttf";